import React from 'react';
import {connect} from 'react-redux';
import {injectIntl, FormattedMessage} from 'react-intl';
import {goToSerp} from '../../../actions/search';
import {getRefinements} from '../../../utils/edap';
import LazyImage from '../../common/lazy-image/LazyImage';
import {UNREFINED_KEY} from '../../../../shared/actions/listings';

function performClick(dispatch, eventrefinements, refinementKey, serpUrlFilters) {
    return () => dispatch(
        goToSerp({
            searchLink: true,
            actionLocation: 'properties-module',
            eventrefinements,
            refinementKey,
            serpUrlFilters
        })
    );
}

export function SeeMorePropertiesCard(props) {
    const {
        intl: {formatMessage, formatNumber},
        dispatch,
        propertyType,
        inventoryCount,
        imageSrc,
        refinementKey,
        serpUrlFilters
    } = props;

    const eventrefinements = getRefinements(propertyType);

    const propertyTypeMessage = formatMessage({
        id: propertyType
    });

    return (
        <div className="great-place__see-more-card" onClick={performClick(dispatch, eventrefinements, refinementKey, serpUrlFilters)}>
            <LazyImage
                className="great-place__see-more-card__image"
                source={imageSrc}
                altText={propertyTypeMessage}
            />
            <div className="great-place__see-more-card__overlay" />
            <div className="great-place__see-more-card__text">
                <FormattedMessage
                    id={`module.placestostay.button.search.${refinementKey}`}
                    defaultMessage={'See all properties'}
                    values={{
                        listingCount: formatNumber(inventoryCount)
                    }}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        propertyType: state.destination.propertyType,
        inventoryCount: state.destination.inventoryCount,
        refinementKey: state.destination.refinementKey || UNREFINED_KEY,
        serpUrlFilters: state.destination.serpUrlFilters
    };
}

export const SeeMorePropertiesConnected = injectIntl(
    connect(mapStateToProps)(SeeMorePropertiesCard)
);
